import { lazy, Suspense, useEffect, useState } from 'react';
import { useLocation } from './router';
import Header from './components/Header';
import Footer from './components/Footer';
import Particles from './components/Particles';

const Home = lazy(() => import('./pages/Home'));
const Projects = lazy(() => import('./pages/Projects'));
const Blog = lazy(() => import('./pages/Blog'));
const Article = lazy(() => import('./pages/Article'));
const Client = lazy(() => import('./pages/Client'));
const NotFound = lazy(() => import('./pages/NotFound'));

function Tracker() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const session = sessionStorage.kingshuk_session_id || crypto.randomUUID();
    sessionStorage.kingshuk_session_id = session;
    fetch('/api/analytics/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ type: 'page_view', path: location.pathname, session }) }).catch(() => {});
    if (location.hash) window.setTimeout(() => document.querySelector(location.hash)?.scrollIntoView({ behavior: 'smooth' }), 150);
  }, [location.pathname, location.hash]);
  return null;
}

export default function App() {
  const [dark, setDark] = useState(() => localStorage.getItem('kingshuk-theme') === 'dark' || (!localStorage.getItem('kingshuk-theme') && matchMedia('(prefers-color-scheme: dark)').matches));

  useEffect(() => {
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    localStorage.setItem('kingshuk-theme', dark ? 'dark' : 'light');
  }, [dark]);

  return (
    <>
      <Tracker />
      <Particles />
      <Header dark={dark} toggleDark={() => setDark((value) => !value)} />
      <main>
        <Suspense fallback={<div className="page-loader"><span>K</span><p>Crafting the details…</p></div>}>
          <RouteView />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

function RouteView() {
  const { pathname } = useLocation();
  if (pathname === '/') return <Home />;
  if (pathname === '/projects') return <Projects />;
  if (pathname === '/journal' || pathname === '/blog') return <Blog />;
  if (pathname.startsWith('/journal/') || pathname.startsWith('/blog/')) return <Article />;
  if (pathname === '/client') return <Client />;
  return <NotFound />;
}
